import { Observable, of } from 'rxjs';
import { MockBackend } from '../mock-backend';
import { STATUS } from 'angular-in-memory-web-api';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { RequestParams } from '../mock-backend';

const payload = require('../data/brand.json');

export class BrandMockService extends MockBackend {
    public static PATH: RegExp = /brand/;
    public get(params: RequestParams): Observable<HttpResponse<any>> {
        return of(new HttpResponse<any>({
            body: payload,
            status: STATUS.OK,
            headers: new HttpHeaders(),
        }));
    }


}
